<template>
  <div>   
       
    <v-container  grid-list-xl> 
        <v-layout align-center="" justify-center="">
            <v-col sm="12" cols="12">
                <v-card>
                    <not-cpanel-tab 
                        :not_show="true"
                        :not="not" /> 
                    <v-card-title class="primary white--text" >
                        <div v-if="!events">
                            <div class="not-f7 font-italic">No events found</div> 
                        </div>
                        <div v-else>
                            <div class="not-f7 font-italic">{{eventsSize}} events, {{eventTypesSize}} event types, {{p_events.list?p_events.list.length:'0'}} Select event</div> 
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn @click="addEvent()" color="white" outlined="" rounded="" small="">Event<v-icon>add_circle</v-icon></v-btn>
                        <v-btn @click="addEventType()" color="white" outlined="" rounded="" small="" class="ml-2">Type<v-icon>add_circle</v-icon></v-btn>
                    </v-card-title> 
                    <v-layout v-if="!page_show">
                        <not-page-spinner :not_show="true" /> 
                    </v-layout> 
                    <div v-else>
                        <v-card-text class="primary lighten-5 px-5">
                            <v-row >
                                <v-col  sm="9" cols="12">
                                    <div class="font-weight-bold not-f6 pb-3">
                                    Type: {{selectedType}}
                                    </div>
                                    <v-sheet v-if="eventsSize===0">
                                        <v-layout align-center="" justify-center="" class="mt-3 pa-10">
                                            <v-icon>warning</v-icon> <div class="ml-2 mt-1 font-weight-bold">No events found</div>
                                        </v-layout>
                                    </v-sheet>
                                    <v-row v-else>
                                        <v-col sm="6" xl="12"  v-for="(study, index) in p_events.list" :key="index">
                                            <v-card :height="'100%'">
                                                <v-layout column="" fill-height class="px-3">
                                                    <v-toolbar max-height="50" :color="study.color.hex" dark>
                                                        <v-icon class="pr-1">event</v-icon>
                                                        <v-toolbar-title>
                                                            {{study.title}}
                                                        </v-toolbar-title>
                                                        <v-spacer></v-spacer>
                                                        <v-btn @click="deleteEvent(study.key)" icon=""><v-icon>delete</v-icon></v-btn>
                                                        <v-btn @click="editEvent(study)" icon=""><v-icon>edit</v-icon></v-btn>
                                                    </v-toolbar>

                                                    <v-card-text> 
                                                        <!-- <v-layout row wrap class="py-2">
                                                        </v-layout> -->
                                                            <div class="font-weight-bold">FROM: {{not.convertDate(study.startDate)}}</div>  
                                                            <div class="font-weight-bold">TO: {{not.convertDate(study.endDate)}}</div> 
                                                        <div>{{study.desc}}</div>
                                                    </v-card-text>
                                                    <v-spacer/><v-spacer/>
                                                    <v-divider></v-divider>
                                                    <v-card-actions class="mb-5" >
                                                        <v-layout class="pa-2">
                                                            <v-spacer></v-spacer>
                                                            <v-btn cl :color="study.color.hex" dark text="" to="/events">View</v-btn>
                                                        </v-layout>
                                                    </v-card-actions>  
                                                </v-layout>     
                                            </v-card> 
                                        </v-col>
                                    </v-row> 
                                </v-col>
                                <v-col sm="3" cols="12">
                                    <v-layout column=""> 
                                        <div class="pl-3 pt-3">
                                            <div class="not-f6 font-weight-bold pb-3">Event Topics</div>
                                            <v-divider></v-divider>
                                            <v-divider></v-divider>
                                            <v-list single-line dense="" color="white">
                                                <v-sheet>
                                                    <v-list-item @click="selectType('All')"  >
                                                        <v-list-item-icon v-if="selectedType==='All'"><v-icon color="primary">check</v-icon></v-list-item-icon>
                                                        <v-list-item-content :class="selectedType==='All'?'primary--text':''">All</v-list-item-content> 
                                                    </v-list-item>
                                                    <v-divider></v-divider>  
                                                </v-sheet>
                                                <v-sheet v-for="(event, index) in eventTypesTopic" :key="index">
                                                    <v-list-item @click="selectType(event.title)" >
                                                        <v-list-item-icon v-if="selectedType===event.title"><v-icon color="primary">check</v-icon></v-list-item-icon>
                                                        <v-list-item-content :class="selectedType===event.title?'primary--text':''">{{event.title}} </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-spacer></v-spacer>
                                                            <v-btn @click.prevent="deleteEventType(event.key)" small="" icon="" :color="selectedType===event.title?'primary':''" ><v-icon size="20">delete</v-icon></v-btn>
                                                        </v-list-item-action>
                                                    </v-list-item>
                                                    <v-divider></v-divider>  
                                                </v-sheet>
                                            </v-list>
                                        </div> 
                                        <div class="pl-3 pt-5">
                                            <div class="not-f6 font-weight-bold pb-2">Event Occasions</div>
                                            <v-divider></v-divider>
                                            <v-divider></v-divider>
                                            <v-list single-line dense="" color="white">
                                                <v-sheet v-for="(event, index) in eventTypesOccasion" :key="index">
                                                    <v-list-item @click="selectType(event.title)">
                                                        <v-list-item-icon v-if="selectedType===event.title"><v-icon color="primary">check</v-icon></v-list-item-icon>
                                                        <v-list-item-content :class="selectedType===event.title?'primary--text':''">{{event.title}} </v-list-item-content>
                                                        <v-list-item-action>
                                                            <v-spacer></v-spacer>
                                                            <v-btn @click="deleteEventType(event.key)" small="" icon="" :color="selectedType===event.title?'primary':''" ><v-icon size="20">delete</v-icon></v-btn>
                                                        </v-list-item-action>
                                                    </v-list-item>
                                                    <v-divider></v-divider>  
                                                </v-sheet>
                                            </v-list>
                                        </div>
                                    </v-layout>
                                </v-col>
                            </v-row>
                            <br>
                            <v-divider></v-divider>
                            <div class="px-5">
                                <v-pagination
                                    v-model="page_current"
                                    class="mt-4"
                                    :length="p_events?p_events.pages:0"/> 
                            </div> 
                        </v-card-text> 
                    </div>
                </v-card>
            </v-col> 
             
        </v-layout>
        <br>
    </v-container> 
    
    <!-- dialog new event -->
    <v-dialog v-model="dialog" persistent max-width="600px"> 
      <v-card color="">
        <v-card-title class="primary white--text" dark>
          <span class="headline">ADD NEW EVENT</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <form id="itemDetailForm" @submit.prevent="submitted()">
                <v-layout row wrap class="pa-1">    
                    <v-flex xs12>
                        <v-layout align-center="" justify-center="">
                            <div>
                            <div class="text-center">Event color</div>
                            <v-color-picker class="ma-2" 
                                v-model="input.color"
                                :swatches="swatches" 
                                show-swatches
                                mode.sync="rgba"
                                hide-canvas=""
                                hide-inputs="" /> 
                            </div>
                        </v-layout>
                    </v-flex>
                    <!-- Title -->
                    <v-flex xs12 sm6  > 
                        <v-text-field required  
                        v-model="input.title" 
                        label="Event Title"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-select required
                            v-model="input.eventType"
                            :items="eventItems"
                            label="Select type"/>
                    </v-flex>
                    <v-flex xs12 sm6 >
                         <v-dialog
                            ref="dialog1"
                            v-model="startD"
                            :return-value.sync="date"
                            persistent 
                            width="290px">
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="input.startDate"
                                label="Start Date" 
                                readonly
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="input.startDate" scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="startD = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog1.save(input.startDate)">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex xs12 sm6 >
                         <v-dialog
                            ref="dialog"
                            v-model="endD"
                            :return-value.sync="date"
                            persistent 
                            width="290px">
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="input.endDate"
                                label="End Date" 
                                readonly
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="input.endDate" scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="endD = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog.save(input.endDate)">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <!-- description -->
                    <v-flex xs12 >
                        <v-textarea background-color="primary lighten-5" 
                            v-model="input.desc" 
                            required  filled=""
                            label="description" >
                            </v-textarea>
                    </v-flex> 

                <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                </v-layout>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text="" @click="dialog = false">CANCEL</v-btn>
                <v-btn color="blue darken-1" :loading="input.loading" dark="" type="submit">ADD</v-btn>
                </v-card-actions>
            </form> 
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        
      </v-card>
    </v-dialog>

    <!-- dialog edit event -->
    <v-dialog v-model="editDialog" persistent max-width="600px"> 
      <v-card color="">
        <v-card-title class="primary white--text" dark>
          <span class="headline">EDIT EVENT</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="editDialog=false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <form id="itemDetailForm" @submit.prevent="submittedEditEvent()">
                <v-layout row wrap class="pa-1">    
                    <v-flex xs12>
                        <v-layout align-center="" justify-center="">
                            <div>
                            <div class="text-center">Event color</div>
                            <v-color-picker class="ma-2" 
                                v-model="SELECTED_EVENT.color"
                                :swatches="swatches" 
                                show-swatches
                                mode.sync="rgba"
                                hide-canvas=""
                                hide-inputs="" /> 
                            </div>
                        </v-layout>
                    </v-flex>
                    <!-- Title -->
                    <v-flex xs12 sm6  > 
                        <v-text-field required  
                        v-model="SELECTED_EVENT.title" 
                        label="Event Title"> 
                        </v-text-field > 
                    </v-flex>   
                    <v-flex xs12 sm6>
                        <v-select required
                            v-model="SELECTED_EVENT.eventType"
                            :items="eventItems"
                            label="Select type"/>
                    </v-flex>
                    <v-flex xs12 sm6 >
                         <v-dialog
                            ref="dialog1"
                            v-model="startD"
                            :return-value.sync="date"
                            persistent 
                            width="290px">
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="SELECTED_EVENT.startDate"
                                label="Start Date" 
                                readonly
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="SELECTED_EVENT.startDate" scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="startD = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog1.save(SELECTED_EVENT.startDate)">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <v-flex xs12 sm6 >
                         <v-dialog
                            ref="dialog"
                            v-model="endD"
                            :return-value.sync="date"
                            persistent 
                            width="290px">
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="SELECTED_EVENT.endDate"
                                label="End Date" 
                                readonly
                                v-on="on"
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="SELECTED_EVENT.endDate" scrollable>
                            <div class="flex-grow-1"></div>
                            <v-btn text color="primary" @click="endD = false">Cancel</v-btn>
                            <v-btn text color="primary" @click="$refs.dialog.save(SELECTED_EVENT.endDate)">OK</v-btn>
                            </v-date-picker>
                        </v-dialog>
                    </v-flex>
                    <!-- description -->
                    <v-flex xs12 >
                        <v-textarea background-color="primary lighten-5" 
                            v-model="SELECTED_EVENT.desc" 
                            required  filled=""
                            label="description" >
                            </v-textarea>
                    </v-flex> 

                <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                </v-layout>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text="" @click="editDialog = false">CANCEL</v-btn>
                <v-btn color="blue darken-1" :loading="SELECTED_EVENT.loading" dark="" type="submit">Edit</v-btn>
                </v-card-actions>
            </form> 
          </v-container>
          <small>*indicates required field</small>
        </v-card-text> 
      </v-card>
    </v-dialog>
    <!-- dialog2 new item -->
    <v-dialog v-model="dialog2" persistent max-width="600px"> 
      <v-card color="b1">
        <v-card-title class="primary white--text" dark>
          <span class="headline">ADD EVENT TYPE</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <form id="itemDetailForm" @submit.prevent="submitted2()">
                <v-layout row wrap class="pa-1">   
                    <!-- Title -->
                    <v-flex xs12  > 
                        <v-text-field required  
                        v-model="input2.title" 
                        label="Event Type"> 
                        </v-text-field > 
                    </v-flex>    
                    <!-- description -->
                    <v-flex xs12 >
                        <v-textarea background-color="primary lighten-5" 
                            v-model="input2.desc" 
                            filled=""
                            label="description if any" >
                            </v-textarea>
                    </v-flex> 

                <v-checkbox
                    v-model="input2.occasion"
                    :label="`Occasion`" /> 
                </v-layout>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text="" @click="dialog2 = false">CANCEL</v-btn>
                <v-btn color="blue darken-1" :loading="input2.loading" dark="" type="submit">ADD</v-btn>
                </v-card-actions>
            </form> 
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        
      </v-card>
    </v-dialog>
  </div> 
</template>

<script>
let pageName = "Events"
    export default {
        name:pageName,
        props:["not"],
        data() {
        return {
            page_current:1,
            page_size:10,

            dialog:false,
            editDialog:false,
            dialog2:false,
            SELECTED_EVENT:[],
            date: new Date().toISOString().substr(0, 10),
            startD:false,
            endD:false,
            swatches: [
                ['#FF0000', '#AA0000', '#550000'],
                ['#FFFF00', '#AAAA00', '#555500'],
                ['#00FF00', '#00AA00', '#005500'],
                ['#00FFFF', '#00AAAA', '#005555'],
                ['#0000FF', '#0000AA', '#000000'], 
            ],
            selectedType:"All",
            page_show:false, 
            tab: null,
            items: [
                'Login', 'Register', ,
            ],
            input:[],
            input2:[],
            images:[
                {src:require(`@/assets/awrim/group/g6.jpeg`),local:true},  
            ] 
        }
        },
        created() {
            this.EventBus.$on('notYesDialog', this.notYesDialog);
        },
        mounted() {
            this.not.NotHeaderNT({
                notShow:true,
                notType:"image",
                notText:false,
                notIndicators:true,
                notHeight:"350",
                notImages:this.images
            })
           this.pageLoad(2000)
        },
        computed: {
            us(){
                return this.not.us
            },
            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            },
            events(){
                return this.$store.getters.getEvents
            },
            eventTypes(){
                return this.$store.getters.getEventTypes
            },
            eventItems(){
                if (!this.eventTypes) {
                    return  null
                }
                let item = []
                this.eventTypes.forEach(event => {
                    let occasion = event.occasion?"occasion":""
                    item.push(event.title)
                });
                return item
            },
            eventTypesOccasion(){
                if (!this.eventTypes) {
                    return  null
                }
                return this.eventTypes.filter(event=>{
                    return event.occasion
                })
            },
            eventTypesTopic(){
                if (!this.eventTypes) {
                    return  null
                }
                return this.eventTypes.filter(event=>{
                    return !event.occasion
                })
            },
            eventsSize(){
                let bs = this.events
               return bs?bs.length:0
            },
            eventTypesSize(){
                let bs = this.eventTypes
               return bs?bs.length:0
            },
            p_events(){ 
                if (!this.events) {
                    return  null
                }
                let ev = this.events.filter(e=>{
                    if (this.selectedType==="All") {
                        return true
                    }
                    return e.eventType == this.selectedType
                })
                let list = [...ev]
                list.sort(this.not.dynamicSort("i",false)) 
                return this.not.pagination(list,this.page_current,this.page_size)
            }
        },
        methods: {
            
            clicked(){},
            notYesDialog(action){
                if (action) {
                    if (action.code ===pageName+"=ADD-EVENT") {
                        if (this.input.check) {
                            this.input.check = false 
                            this.$store.dispatch("fi_add",{
                                action:"Event",
                                path:"TERESIAN/SETTINGS/Events/",
                                data:action.data
                            }) 
                        } 
                    }else if (action.code ===pageName+"=EDIT-EVENT") {
                        if (this.input.check) {
                            this.input.check = false 
                            this.$store.dispatch("fi_update",{
                                action:"Event",
                                path:"TERESIAN/SETTINGS/Events/"+action.data.key,
                                data:action.data
                            }) 
                        } 
                    }else if (action.code===pageName+"=ADD-EVENT-SUCCESSFUL") {
                        this.input = {}
                        this.dialog = false
                    }else if (action.code===pageName+"=DELETE-EVENT") {  
                        this.$store.dispatch("fi_delete",{
                            action:"Event",
                            path:"TERESIAN/SETTINGS/Events/"+action.key
                        })
                    }else if (action.code===pageName+"=ADD-EVENT-TYPE") { 
                        if (this.input2.check) {
                            this.input2.check = false   
                            this.$store.dispatch("fi_add",{
                                action:"EventType",
                                path:"TERESIAN/SETTINGS/EventTypes/",
                                data:action.data
                            }) 
                        } 
                    }else if (action.code===pageName+"=DELETE-EVENT-TYPE") {  
                        this.$store.dispatch("fi_delete",{
                            action:"EventType",
                            path:"TERESIAN/SETTINGS/EventTypes/"+action.key
                        })
                    }else if (action.code===pageName+':'+7) {
                        this.input2 = {}
                        this.dialog2 = false
                    }
                }
            },
            addEvent(){
                this.input = {}
                this.dialog = !this.dialog
            },
            editEvent(event){
                this.SELECTED_EVENT = {...event}
                this.editDialog = true
            },
            addEventType(){
                this.input2 = {}
                this.dialog2 = !this.dialog2
            },
            submitted(){
                this.input.check = true 
                if (!this.input.startDate) {
                    this.not.notDialog(true,true,"ERROR","Starting date is required.","","OK", )
                }else if (!this.input.endDate) {
                     this.not.notDialog(true,true,"ERROR","Ending date is required.","","OK", )
                } else {
                    this.not.notDialog(true,true,"ADD","You are about to add new event.","Cancel","Add",{
                        code:pageName+"=ADD-EVENT",
                        data:this.input
                    })
                }  
            },
            submittedEditEvent(){
                this.input.check = true 
                if (!this.SELECTED_EVENT.startDate) {
                    this.not.notDialog(true,true,"ERROR","Starting date is required.","","OK", )
                }else if (!this.SELECTED_EVENT.endDate) {
                     this.not.notDialog(true,true,"ERROR","Ending date is required.","","OK", )
                } else {
                    this.not.notDialog(true,true,"EDIT EVENT","You are about to edit this event.","Cancel","Edit",{
                        code:pageName+"=EDIT-EVENT",
                        data:this.SELECTED_EVENT
                    })
                }  
            },
            submitted2(){
                this.input2.check = true 
                this.not.notDialog(true,true,"ADD","You are about to add event type.","Cancel","Add",{
                    code:pageName+"=ADD-EVENT-TYPE",
                    data:this.input2
                })
            },
            deleteEvent(key){
                this.not.notDialog(true,true,"DELETE","You are about to delete this event.","Cancel","Delete",{
                    code:pageName+"=DELETE-EVENT",
                    key:key
                })
            },
            deleteEventType(key){
                this.not.notDialog(true,true,"DELETE","You are about to delete this event type.","Cancel","Delete",{
                    code:pageName+"=DELETE-EVENT-TYPE",
                    key:key
                })
            },
            selectType(type){
                this.selectedType = type
            },
            //LOAD
            show(){
                if (!this.us) {
                    this.not.go("/")
                }
            },
            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses 

                   //CHECK USER PROCESS 
                    if (ps) {
                        let getting = ps.find(process=>{
                            return process.name == 'getting/Events'
                        })
                        let adding = ps.find(process=>{
                            return process.name == 'adding/Event'
                        })
                        let updating = ps.find(process=>{
                            return process.name == 'updating/Event'
                        })
                        let deleting = ps.find(process=>{
                            return process.name == 'deleting/Event'
                        }) 
                        let addingT = ps.find(process=>{
                            return process.name == 'adding/EventType'
                        })
                        let deletingT = ps.find(process=>{
                            return process.name == 'deleting/EventType'
                        }) 

                        if (getting) {
                            this.page_show =false
                        }else{
                            this.page_show =true
                        }

                        if (adding) {
                            this.not.notDialogP(true,true,'adding...')
                            this.input.loading = true
                        }else{ 
                        } 
                        if (updating) {
                            this.not.notDialogP(true,true,'updating...')
                            this.input.loading = true
                        }else{ 
                        }  
    
                        if (deleting) {
                            this.not.notDialogP(true,true,'deleting...') 
                        }else{ 
                        }  

                        if (addingT) {
                            this.not.notDialogP(true,true,'adding...')
                            this.input.loading = true
                        }else{ 
                        }  
    
                        if (deletingT) {
                            this.not.notDialogP(true,true,'deleting...') 
                        }else{ 
                        } 

                        
                    }else{
                        this.page_show =true
                    }

                    //check response
                    if (res.res==='adding/Event/successful') { 
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.notDialog(true,true,'Successful','event, successfulLy added.','','OK',{
                            code:pageName+"=ADD-EVENT-SUCCESSFUL"
                        })
                        this.not.restartResponses()
                    }else if (res.res==='adding/Event/error'){ 
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.notDialog(true,true,'Not Successful','Error while adding event.','Cancel','Try again')
                        this.not.restartResponses()
                    }
                    //update
                    if (res.res==='updating/Event/successful') { 
                        this.input.loading = false
                        this.input.SELECTED_EVENT = []
                        this.editDialog=false
                        this.not.notDialogP(false) 
                        this.not.notDialog(true,true,'Successful','event, successfulLy updated.','','OK',{
                            code:pageName+"=ADD-EVENT-SUCCESSFUL"
                        })
                        this.not.restartResponses()
                    }else if (res.res==='updating/Event/error'){ 
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.notDialog(true,true,'Not Successful','Error while updating event.','Cancel','Try again')
                        this.not.restartResponses()
                    }

                    if (res.res==='deleting/Event/successful') { 
                        this.not.notDialog(true,true,'Successful','event, successfulLy deleted.','','OK') 
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='delete/Event/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting event.','','OK') 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                    //
                    if (res.res==='adding/EventType/successful') { 
                        this.not.notDialog(true,true,'Successful','event type, successfulLy added.','','OK',{code:pageName+':'+7})
                        this.input2.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='adding/EventType/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while adding event type.','','OK')
                        this.input2.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }

                    if (res.res==='deleting/EventType/successful') { 
                        this.not.notDialog(true,true,'Successful','event type, successfulLy deleted.','','OK')  
                        this.not.notDialogP(false) 
                        this.not.restartResponses()
                    }else if (res.res==='deleting/EventType/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while deleting event type.','','OK') 
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    }
                },t)
            }
        },
        watch: {
            us(v){
                this.show()
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
  }
</script>
 
